import styled from "styled-components";

export default styled.div`
  padding-top: 4rem;
  height: 100%;
`;
